/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronDownIcon, UserIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const BuyForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    paymentMethod: 'googlepay',
    coin: 'BTC',
    network: 'Bitcoin',
    fullName: '',
    email: '',
    walletAddress: '',
    amount: 1000,
    btcAmount: 0.0003748
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const nextStep = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const PaymentMethodSection = () => (
    <div className="space-y-6">
      <h2 className="text-2xl font-medium text-black">Choose Payment Method</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-5">
        {
          [1, 2, 3]?.map((a) => {
            return (
              <div key={a} className="bg-white rounded-lg shadow-md p-6 border border-gray-200 cursor-pointer hover:border-green-500 transition-colors">
                <div className="flex justify-center h-[50px]">
                  <img src="/images/bitcoin-logo.png" alt="Bitcoin" className="w-16 object-contain" />
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  );

  const UserDetailsSection = () => (
    <div className="space-y-6">

      <div className="space-y-4 mt-4">
        {/* Full Name */}
        <div>
          <div className="relative bg-white rounded-lg shadow-md border border-gray-200">
            <div className="flex items-center p-4">
              <UserIcon className="w-6 h-6 text-[#56B22F] mr-3" />
              <input
                type="text"
                placeholder="Full Name"
                className="flex-1 text-lg text-gray-500 bg-transparent outline-none"
                value={formData.fullName}
                onChange={(e) => handleInputChange('fullName', e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Email Address */}
        <div>
          <div className="relative bg-white rounded-lg shadow-md border border-gray-200">
            <div className="flex items-center p-4">
              <EnvelopeIcon className="w-6 h-6 text-[#56B22F] mr-3" />
              <input
                type="email"
                placeholder="Email Address"
                className="flex-1 text-lg text-gray-500 bg-transparent outline-none"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Coin Selection */}
        <div>
          <label className="block text-lg font-medium text-black mb-2">Coin</label>
          <div className="relative bg-white rounded-lg shadow-md border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <div className="w-7 h-7 bg-orange-500 rounded-full flex items-center justify-center">
                <svg viewBox="0 0 28 28" className="w-4 h-4 text-white">
                  <path fill="currentColor" d="M14 28C6.27 28 0 21.73 0 14S6.27 0 14 0s14 6.27 14 14-6.27 14-14 14z" />
                  <path fill="white" d="M6.81 4.88c1.4-1.77 3.5-2.9 5.9-2.9 2.39 0 4.5 1.13 5.9 2.9" />
                </svg>
              </div>
              <span className="text-lg font-medium text-black">Bitcoin</span>
            </div>
          </div>
        </div>

        {/* Network Selection */}
        <div>
          <label className="block text-lg font-medium text-black mb-2">Network</label>
          <div className="relative bg-white rounded-lg shadow-md border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <span className="text-lg font-medium text-black">Bitcoin</span>
            </div>
          </div>
        </div>

        {/* Wallet Address */}
        <div>
          <label className="block text-lg font-medium text-black mb-2">Wallet Address</label>
          <div className="relative bg-white rounded-lg shadow-md border border-gray-200">
            <div className="flex items-center p-4">
              <svg className="w-6 h-6 text-[#56B22F] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <input
                type="text"
                placeholder="Enter wallet address - BTC"
                className="flex-1 text-lg text-gray-500 bg-transparent outline-none"
                value={formData.walletAddress}
                onChange={(e) => handleInputChange('walletAddress', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const ReviewPaySection = () => (
    <div className="space-y-6 mt-6">
      <label className="block text-lg font-medium text-black mb-2">Purchase Details</label>
      {/* Amount Display */}
      <div className="flex items-center justify-center space-x-4 mb-6">
        <div className="text-center">
          <div className="text-lg font-medium text-gray-800">1000EUR</div>
        </div>
        <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
        <div className="text-center">
          <div className="text-lg font-medium text-gray-800">0.0003748 BTC</div>
        </div>
      </div>

      {/* Fee Information */}
      <div className="bg-gray-50 rounded-lg p-6 space-y-2">
        <div className="text-lg text-black leading-relaxed">
          <div>Processing fee :    6.99 EUR</div>
          <div>Blockchain fee :    0.00000786 BTC</div>
          <div>Rate:                        1 BTC = 97,860.85 EUR</div>
        </div>
      </div>

      {/* Total Payment */}
      <div className="bg-gray-100 rounded-lg p-6">
        <div className="flex justify-between items-center">
          <span className="text-2xl font-medium text-black">Total Payment</span>
          <span className="text-2xl font-semibold text-[#56B22F]">1000 EUR</span>
        </div>
      </div>

      {/* Pay Now Button */}
      <button className="w-full bg-[#56B22F] text-white text-xl font-semibold py-4 rounded-lg hover:bg-green-600 transition-colors">
        Pay Now
      </button>

      {/* Back to Home */}
      <div className="text-center">
        <button className="text-lg text-black hover:text-[#56B22F] transition-colors">
          Back to Home
        </button>
      </div>
    </div>
  );

  const StepIndicator = ({ step, title, isActive, isCompleted }) => (
    <div className="flex items-start justify-end gap-10">
      <div className="text-center shadow-[0px_0px_6px_0px_#00000040] h-[110px] w-[180px] rounded-lg flex flex-col items-center justify-center p-3">
        <div className="text-lg font-medium text-[#56B22F] mb-1">Step {step}</div>
        <div className="text-lg font-medium text-[#56B22F] leading-tight">{title}</div>
      </div>
      <div className="flex items-center mb-2">
        <div className={`w-5 h-5 rounded-full ${isActive || isCompleted ? 'bg-[#56B22F]' : 'bg-white border-2 border-gray-300'} flex items-center justify-center`}>
          {(isActive || isCompleted) && <div className="w-3 h-3 bg-white rounded-full"></div>}
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto p-8">

        <div className="flex justify-center gap-12">
          <div className="flex pt-56 relative">
            {/* Step Indicators */}
            <div className="flex flex-col gap-12 relative z-10 ml-4">
              <StepIndicator
                step={1}
                title={<span>Choose Payment <br/> Method</span>}
                isActive={currentStep === 1}
                isCompleted={currentStep > 1}
              />
              <StepIndicator
                step={2}
                title="User Details"
                isActive={currentStep === 2}
                isCompleted={currentStep > 2}
              />
              <StepIndicator
                step={3}
                title="Review & Pay"
                isActive={currentStep === 3}
                isCompleted={false}
              />
            </div>
            <div className="absolute right-[-5px] h-full w-8 flex flex-col items-center">
              {/* Vertical line */}
              <div className="absolute top-0 bottom-0 left-1/2 w-1 bg-[#56B22F] transform -translate-x-1/2 z-0"></div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="flex items-center justify-center mb-8">
              <h1 className="text-2xl font-semibold text-[#56B22F]">Buy</h1>
            </div>
            <div className="mb-8">
              <h2 className="text-2xl font-medium text-black mb-2">Buy BTC</h2>

              <div className="w-full h-5 border-[#CECECE] border bg-[#F7F7F7] relative">
                <div className="absolute h-[17.5px] bg-[#56B22F]" style={{ width: currentStep == 1 ? "33.33%" : currentStep == 2 ? "66.66%" : '100%' }}>

                </div>
              </div>


            </div>
            {/* Step Content */}
            {(currentStep === 1 || currentStep === 2 || currentStep === 3) && <PaymentMethodSection />}
            {(currentStep === 2 || currentStep === 3) && <UserDetailsSection />}
            {currentStep === 3 && <ReviewPaySection />}

            {/* Navigation Buttons */}
            {currentStep < 3 && (
              <div className="flex justify-end mt-8">
                <button
                  onClick={nextStep}
                  className="bg-[#56B22F] text-white px-8 py-3 rounded-lg hover:bg-green-600 transition-colors font-medium"
                >
                  Continue
                </button>
              </div>
            )}

            {currentStep > 1 && currentStep < 3 && (
              <div className="flex justify-between mt-8">
                <button
                  onClick={prevStep}
                  className="text-[#56B22F] px-8 py-3 rounded-lg hover:bg-green-50 transition-colors font-medium"
                >
                  Back
                </button>
                <button
                  onClick={nextStep}
                  className="bg-[#56B22F] text-white px-8 py-3 rounded-lg hover:bg-green-600 transition-colors font-medium"
                >
                  Continue
                </button>
              </div>
            )}
          </div>

        </div>


      </div>
    </div>
  );
};

export default BuyForm; 